// extracted by mini-css-extract-plugin
export default {"error":"acb82ef94047"};